import { AllBranchManagementBranchesDto, BranchManagementBranchesDto } from '@core/services/dto/branch-management-branches.dto';
import { formateUTCtoTZ } from '@shared/utils';

export class BranchManagementModel {
  id: number;
  name: string;
  email: string;
  isPrimary: boolean | string;
  isDefault: boolean;
  isActive: boolean;
  transitNumber: string;
  phoneNumber: string;
  region: string;
  lastLogin: string;
  status: string;
  default: boolean;
  created: string;
  modified: string;
  enableForOrigination: boolean;
  enableForApplication: string;
  externalIntegrationIdentifiers: string;
  trashIcon: boolean;
  primaryIcon: boolean;

  constructor(dto: BranchManagementBranchesDto) {
    this.name = dto.name;
    this.email = dto.email;
    this.isPrimary = dto.isPrimary;
    this.region = dto.region;
    this.id = dto.id;
    this.transitNumber = dto.transitNumber;
    this.lastLogin = dto.lastLogin ? formateUTCtoTZ(dto.lastLogin) : 'N/A';
    this.modified = dto.lastModified ? formateUTCtoTZ(dto.lastModified) : 'N/A';
    this.isDefault = dto.isDefault;
    this.isActive = dto.isActive;
    this.status = dto.isActive=== true ? 'Active' : 'InActive';
    this.default = dto.isDefault;
    this.isPrimary = dto.isPrimary;
    this.phoneNumber = dto.phoneNumber;
    this.created = dto.created ? formateUTCtoTZ(dto.created) : 'N/A';
    this.enableForApplication = dto.enableForOrigination === true ? 'Yes' : 'No';
    this.enableForOrigination = dto.enableForOrigination;
    this.externalIntegrationIdentifiers = dto.externalIntegrationIdentifiers;
  }
}

export class AllBranchManagementModel {
  id: number;
  name: string;

  constructor(dto: AllBranchManagementBranchesDto) {
    this.id = dto.id;
    this.name = dto.name;
  }
}
